<script>
import { BDropdownItem } from "bootstrap-vue";

export default {
  extends: BDropdownItem
};
</script>